import(/* webpackMode: "eager" */ "/home/deploy/proyecto/fs-negotium/apps/customer-portal/app/[lng]/loading.tsx");
